export default `
  query urlRewriteStoreQuery($url: String!) {
    urlRewriteStoreViews(url: $url) {
      type
      relative_urls {
        store_id
        url
      }
      entity_uid
    }
  }
`;
